<div  class="card">
    <div class="text-center">
        <i class="fa fa-user fa-4x"></i>
    </div>
    <h4 class="card-header">Create New Syllabus</h4>
    <div class="card-body">
        <div class="alert alert-danger text-center" *ngIf="errorEncountered">
            Error Creating Syllabus
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="form-group row mt-2" [ngClass]="{error:f.syllabusCode.errors && f.syllabusCode.touched}">
            <label for="syllabusCode" class='control-label col-sm-3'>Syllabus Code<span class="required-asteric">*</span></label>
                <div class=" col-sm-8">

                <input  type="text" formControlName="syllabusCode" class="form-control" [ngClass]="{ 'is-invalid': f.syllabusCode.errors && f.syllabusCode.touched }" />
                <div *ngIf="f.syllabusCode.errors && f.syllabusCode.touched" class="invalid-feedback">
                    <div *ngIf="f.syllabusCode.errors.required">Syllabus Code is required</div>
                </div>
            </div>
            </div>

            <div class="form-group row mt-2" [ngClass]="{error:f.description.errors && f.description.touched}">
              <label for="description" class='control-label col-sm-3'>Description<span class="required-asteric">*</span></label>
                  <div class="col-sm-8">
                    <input type="text" id="description" formControlName="description" class="form-control">
                      <div *ngIf="f.description.errors && f.description.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                          <ul>
                              <li>Description Required.</li>
                          </ul>
                      </div>
                  </div>
            </div>
            <div class="form-group row input-group-lg mt-2">
                <div class="col-sm-6 offset-sm-3">
                <button [disabled]="loading" class="btn btn-primary btn-lg btn-block">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                    Submit
                </button>
            </div>
            </div>
        </form>
    </div>


</div>
